import React from 'react';

interface TitleProps {
  title: string | React.ReactElement;
  subTitle?: string;
  className?: string;
  titleStyle?: any;
}

export const Title: React.FC<TitleProps> = ({
  title,
  subTitle,
  className,
  titleStyle,
}) => {
  return (
    <div className={`text-primary ${className || ''}`}>
      <h1
        className=" text-[52px] leading-[74px] mobile:text-[28px] mobile:leading-[38px] font-500 line-clamp-1 mobile:line-clamp-none"
        style={titleStyle}
      >
        {title}
      </h1>
      {subTitle && (
        <h3
          className=" text-2xl leading-[34px] mt-1 mobile:leading-none mobile:text-base mobile:mt-[6px] text-primary/60 font-400"
          dangerouslySetInnerHTML={{ __html: subTitle }}
        />
      )}
    </div>
  );
};
